import { IDeclaration, IFunction } from '../editor/index.d';


/**
 * 将 declaration 转化为对象结构
 * @param declaration IDeclaration
 */
export function transformDeclarationToObject(declaration: IDeclaration) {
  return typeof declaration === 'string' ? {
    code: declaration, name: declaration
  } : declaration;
}

/**
 * 将 declarations 数组转化为对象结构
 * @param declarations IDeclaration[]
 */
export function transformDeclarationsToObject(declarations: IDeclaration[]) {
  return declarations.map(transformDeclarationToObject);
}

/**
 * 将 declaration 转化为字符串结构
 * @param declaration IDeclaration
 */
export function transformDeclarationToString(declaration: IDeclaration) {
  return typeof declaration === 'string' ? declaration : declaration.code;
}

/**
 * 将 declarations 数组转化为字符串结构
 * @param declarations IDeclaration[]
 */
export function transformDeclarationsToString(declarations: IDeclaration[]) {
  return declarations.map(transformDeclarationToString);
}


/**
 * 将 function 转化为对象结构
 * @param func IFunction
 */
export function transformFunctionToObject(func: IFunction) {
  return typeof func === 'string' ? {
    code: func, name: func
  } : func;
}

/**
 * 将 functions 数组转化为对象结构
 * @param functions IFunction[]
 */
export function transformFunctionsToObject(functions: IFunction[]) {
  return functions.map(transformFunctionToObject);
}

/**
 * 将 function 转化为字符串结构
 * @param func IFunction
 */
export function transformFunctionToString(func: IFunction) {
  return typeof func === 'string' ? func : func.code;
}

/**
 * 将 functions 数组转化为字符串结构
 * @param functions IFunction[]
 */
export function transformFunctionsToString(functions: IFunction[]) {
  return functions.map(transformFunctionToString);
}
